module.exports = __webpack_public_path__ + "static/media/pic4.fd039ced.jpg";